import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Timer, Ruler, Activity, Database, LogOut, Shield, CreditCard } from 'lucide-react';
import { useAuthStore } from '../stores/authStore';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, user, isAdmin } = useAuthStore();

  const navigation = [
    { name: 'Speed', icon: Timer, href: '/speed' },
    { name: 'Pitch&Stride', icon: Ruler, href: '/pitch' },
    { name: 'Contact&Flight', icon: Activity, href: '/contact' },
    { name: 'Data', icon: Database, href: '/settings' },
    { name: 'Subscription', icon: CreditCard, href: '/subscription' },
  ];

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-primary-600">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 items-center justify-between">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <span 
                  className="text-white text-xl font-bold cursor-pointer"
                  onClick={() => navigate('/')}
                >
                  Sprint Analysis
                </span>
              </div>
              <div className="hidden md:block">
                <div className="ml-10 flex items-baseline space-x-4">
                  {navigation.map((item) => (
                    <button
                      key={item.name}
                      onClick={() => navigate(item.href)}
                      className={`text-white hover:bg-primary-500 px-3 py-2 rounded-md text-sm font-medium ${
                        location.pathname === item.href ? 'bg-primary-700' : ''
                      }`}
                    >
                      <item.icon className="h-5 w-5 inline-block mr-1" />
                      {item.name}
                    </button>
                  ))}
                  {isAdmin && (
                    <button
                      onClick={() => navigate('/new-admin')}
                      className={`text-white hover:bg-primary-500 px-3 py-2 rounded-md text-sm font-medium ${
                        location.pathname === '/new-admin' ? 'bg-primary-700' : ''
                      }`}
                    >
                      <Shield className="h-5 w-5 inline-block mr-1" />
                      Admin
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              {user?.organization && (
                <span className="text-white text-sm">
                  {user.organization}
                </span>
              )}
              <button
                onClick={handleLogout}
                className="text-white hover:bg-primary-500 px-3 py-2 rounded-md text-sm font-medium flex items-center"
              >
                <LogOut className="h-5 w-5 mr-1" />
                ログアウト
              </button>
            </div>
          </div>
        </div>
      </nav>

      <main className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-6">
        {children}
      </main>
    </div>
  );
};

export default Layout;